export const getRecentCallList = state => state.onlineStateReducer.callList;
export const getTeam = state => state.onlineStateReducer.team;



// WEBPACK FOOTER //
// src/store/selector/online.selector.js